// extracted by mini-css-extract-plugin
module.exports = {"emailsDashboardContainer":"EmailsDashboard_emailsDashboardContainer__R5EH0","loaderContainer":"EmailsDashboard_loaderContainer__SmZ02","infoText":"EmailsDashboard_infoText__2rLV2"};